import localeCs from '@angular/common/locales/cs';
import localeCsExtra from '@angular/common/locales/extra/cs';

import { LanguageEnum, Language } from '../core/interfaces/language-types';

export default class CzechLanguage extends Language {
  protected locale = localeCs;
  protected localeExtra = localeCsExtra;
  protected details = {
    image: 'images/flags/cs.png',
    title: 'Czech',
    enum: LanguageEnum.Czech,
    aira: 'Czech Selected',
    select: 'Choose Czech Language',
    abre: 'cs'
  };
}
